import { render } from "./select.vue?vue&type=template&id=27acd3ce&scoped=true"
import script from "./select.vue?vue&type=script&lang=js"
export * from "./select.vue?vue&type=script&lang=js"

import "./select.vue?vue&type=style&index=0&id=27acd3ce&lang=css"
import "./select.vue?vue&type=style&index=1&id=27acd3ce&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27acd3ce"]])

export default __exports__